import React, { useEffect, useState } from "react";

import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import { IEquipeUsuario } from "../../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import {
    DesvincularUsuarioEquipeController,
    ListarUsuariosNaoVincladoPorEquipeController,
    ListarUsuariosVincladoPorEquipeController,
    VincularUsuarioEquipeController,
} from "../../../../../Controllers/HelpDesk/Equipes/EquipeUsuarioControllers";
import { useForm } from "react-hook-form";

import "./styles.css";

interface UsuariosProps {
    ID_FILA: number;
}
interface ITableRowProps {
    row: IEquipeUsuario;
}

export default function Usuarios(props: UsuariosProps) {
    const [lstUsuariosVinculados, setLstUsuariosVinculados] = useState([
        {},
    ] as Array<IEquipeUsuario>);
    const [lstUsuariosDesvinculados, setLstUsuariosDesvinculados] = useState([
        {},
    ] as Array<IEquipeUsuario>);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (props.ID_FILA !== 0) updateUsuarios(props.ID_FILA);
    }, [props.ID_FILA]);

    function updateUsuarios(ID_FILA: number) {
        setLoading(true);
        ListarUsuariosVincladoPorEquipeController(ID_FILA).then((res) => {
            setLstUsuariosVinculados(res);
            setLoading(false);
        });
        ListarUsuariosNaoVincladoPorEquipeController(ID_FILA).then((res) => {
            setLstUsuariosDesvinculados(res);
            setLoading(false);
        });
    }

    //Tabela de Usuarios Vinculados
    const columnsUsuariosVinculados: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME",
            text: "Usuários Vinculados",
            formatter: RowUsuarioVinculado,
            sort: true,
        },
    ];

    function RowUsuarioVinculado(cell: any, row: IEquipeUsuario) {
        return (
            <div className="d-flex row justify-content-between align-items-center">
                <label className="col-12 col-lg-6 text-break mb-0">
                    {row.DS_NOME}
                </label>
                <div className="col-12 col-lg-6 d-flex flex-wrap flex-row align-items-end">
                    <div className="mb-0 mr-3">
                        <label>Ordem {row.NR_ORDEM}</label>
                    </div>
                    <div className="mb-0 mr-3">
                        <label>Limite de {row.NR_LIMITE_CHAT} chats</label>
                    </div>
                    <button
                        className="btn btn-sm btn-outline-danger font-weight-bold mx-2 d-flex align-items-center justify-content-center flex-nowrap"
                        onClick={() => {
                            DesvincularUsuarioEquipeController(row).then(
                                (response) => {
                                    updateUsuarios(props.ID_FILA);
                                }
                            );
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowDown}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Desvincular
                    </button>
                </div>
            </div>
        );
    }
    //Tabela Usuarios Desvinculados
    const columnsUsuariosDesvinculados: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME",
            text: "Usuários Desvinculados",
            formatter: (cell, row: IEquipeUsuario) => (
                <RowUsuarioDesvinculado row={row} />
            ),
            sort: true,
        },
    ];

    function RowUsuarioDesvinculado(rowProps: ITableRowProps) {
        const { row } = rowProps;
        const { register, handleSubmit, watch } = useForm<IEquipeUsuario>();

        const watcher = watch();

        function handleVincularUsuarioForm(formData: IEquipeUsuario) {
            VincularUsuarioEquipeController({
                ...row,
                NR_ORDEM: formData.NR_ORDEM,
                NR_LIMITE_CHAT: formData.NR_LIMITE_CHAT,
                ID_EQUIPE_HELP_DESK: props.ID_FILA,
            }).then(() => {
                updateUsuarios(props.ID_FILA);
            });
        }
        return (
            <form
                onSubmit={handleSubmit(handleVincularUsuarioForm)}
                className="d-flex flex-wrap justify-content-between align-items-center"
            >
                <label className="col-12 col-lg-6 text-break">
                    {row.DS_NOME}
                </label>

                <div className="col-12 col-lg-6 d-flex flex-wrap flex-row align-items-center">
                    <div className="form-group number-sm-input mb-0">
                        <label>Ordem na Fila</label>
                        <input
                            type="number"
                            className="form-control"
                            name="NR_ORDEM"
                            ref={register({ valueAsNumber: true })}
                        />
                    </div>
                    <div className="form-group number-sm-input mb-0">
                        <label>Limite de chats</label>
                        <input
                            type="number"
                            className="form-control"
                            name="NR_LIMITE_CHAT"
                            ref={register()}
                        />
                    </div>
                    <button
                        className="btn btn-sm btn-outline-success font-weight-bold mx-2 d-flex align-items-center justify-content-center flex-nowrap mt-2   "
                        disabled={
                            !watcher.NR_LIMITE_CHAT ||
                            !watcher.NR_LIMITE_CHAT ||
                            watcher.NR_LIMITE_CHAT <= 0 ||
                            watcher.NR_ORDEM <= 0 ||
                            !lstUsuariosVinculados.every(
                                (equipe) => equipe.NR_ORDEM !== watcher.NR_ORDEM
                            )
                        }
                    >
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Vincular
                    </button>
                </div>
            </form>
        );
    }

    return !loading ? (
        <>
            <h3>Usuários por equipe</h3>
            <div className="row flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                <div className="col-12">
                    <Table
                        keyField="ID_USUARIO"
                        columns={columnsUsuariosVinculados}
                        data={lstUsuariosVinculados}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
                <div className="col-12">
                    <Table
                        keyField="ID_USUARIO"
                        columns={columnsUsuariosDesvinculados}
                        data={lstUsuariosDesvinculados}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
